import React from "react";
import Navbar from "../../components/navbar/Navbar";
import { Box } from "@mui/material";
import ContactUs from "../../components/contactus/contactUs";
import Footer from "../../components/Footer/Footer";

const ContactUsPage = () => {
	return (
		<Box>
	  <Navbar />
		<ContactUs />
		<Footer />
		</Box>
	);
};

export default ContactUsPage;
